const APP: string = 'Smart-Home'
const I18N_KEY: string = `${APP}_i18n`
export { APP, I18N_KEY }
export const localStorageBreadcrumbKey = 'breadcrumbs'
